import React, { useEffect, useReducer, useRef  } from "react";

// Interface for component state
interface InputRangeState {
	value: number;
}

// Interface for component props
interface InputRangeProps {
	value?: number;
	min: number;
	max: number;
	tools?: boolean;
	dispatch: (action: [string, number]) => void;
}

const InputRangeReducer = function( state: InputRangeState, [ type, data ]: [string, number] ): InputRangeState {

	if( type === "value" ){
		return {
			...state,
			value: data
		};
	};

	return state;
};

export const InputRange = ( props: InputRangeProps ) => {

	const [ state, dispatch ] = useReducer( InputRangeReducer, {
		value: props.value || 0
	});
	useEffect(() => {
		dispatch([ "value", props.value! ]);
	}, [ props.value ]);

	return(
		<div className={"range" + (props.tools ? " mb-range": "")}>
			<input className={"range-line"}
				type={ "range" }
				min={ props.min }
				max={ props.max }
				value={ state.value }
				onChange={( e: React.ChangeEvent<HTMLInputElement> ) => props.dispatch([ "range", parseInt(e.target.value) ]) }
			/>
		</div>
	);
};